<template>
  <div>
    <Header/>
    <router-view/>
    <!-- <Footer v-show="$route.path !== '/login' && $route.path !== '/register'"/> -->
    <Footer v-show="!$route.meta.isHideFooter"/>
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'

  export default {
    name:'App',
    components:{Header,Footer},
  }
</script>

<style lang="less">
  .demo {
    background-color: green;
    padding: 10px;
    color: white;
    font-size: 20px;
  }
</style>